export const DEVELOPMENT_INFO_FILENAME = 'development-info.json';
export const TRANSLATIONS_CACHE_MAX_AGE = 15;
export const TRANSLATIONS_ENDPOINT = '/system/ajax/Localization/Translate';
export const TRANSLATIONS_KEYS = 'keys';
/** User ID for user that is not logged in */

export const NOT_LOGGED_IN_USER_ID = -1;
export const SUPPORTED_ERROR_CODES = [0, 400, 401, 403, 404, 429, 500, 502, 503, 504];
export const DEFAULT_TENANT = 'uk';
export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_LOCALE = 'en';
export * from "./environment";
//# sourceMappingURL=index.js.map